import React, { useContext, useState } from "react";
import { Nav, Navbar } from "react-bootstrap";
import { Link } from "react-scroll";
import { UserContext } from "../../App";
import "./NavBar.css";

const NavBar = () => {
  const [navbar, setNavbar] = useContext(UserContext);

  return (
    <Navbar
      className={navbar ? "header_nav active" : "header_nav"}
      expand="lg"
      sticky="top"
    >
      <div className="container">
        <Navbar.Brand
          style={{ color: "#fff", fontSize: "30px", fontWeight: "500px" }}
          href="#home"
        >
          Hadid <span style={{ color: "black" }}>Billa</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto d-flex align-items-center">
            <Link id="navigation-bar" to="home">
              Home
            </Link>
            <Link id="navigation-bar" to="About" smooth={true} duration={1000}>
              About
            </Link>
            <Link
              id="navigation-bar"
              to="Services"
              smooth={true}
              duration={1000}
            >
              Services
            </Link>
            <Link id="navigation-bar" to="Skills" smooth={true} duration={1000}>
              Skills
            </Link>
            <Link
              id="navigation-bar"
              to="Projects"
              smooth={true}
              duration={1000}
            >
              Projects
            </Link>
            <Link
              id="navigation-bar"
              to="Contact"
              smooth={true}
              duration={1000}
            >
              Contact
            </Link>
            <Link id="navigation-bar" to="home" smooth={true} duration={1000}>
              Blog
            </Link>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default NavBar;
